import { useMutation } from '@tanstack/react-query';
import { applyAuthenticatedSession } from 'services/auth/session';
import { LoginDto, LoginEntity, UserWalletAuthService } from 'services/openapi';
import { formatPhoneNumber } from 'utils/helpers';

const convertVariables = (variables: LoginDto) => {
  const { phoneNumber, ...rest } = variables;

  return {
    phoneNumber: formatPhoneNumber(phoneNumber),
    ...rest,
  };
};

export const useLoginMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<LoginEntity, Error, LoginDto>({
      mutationFn: (variables: LoginDto) => {
        return UserWalletAuthService.authControllerLogin(
          convertVariables(variables),
        );
      },
      onSuccess: (res) => {
        if (!res.mfaRequired) applyAuthenticatedSession();
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
